<div class="main">
    <div class="section">
      <div class="header">
        {{'VIEW_ATTENDANCE.title' | translate}}
        <i class="material-icons" (click)="closeDialog();">clear</i>
      </div>
      <div class="container">
        <div class="dates">
         {{driver_data.driver_name}} - {{driver_data.driver_mobile}}
          <!-- {{expense.driver_name}} -->
        </div>
        <div class="dates">
          <div class="select-date">
            <div>
              <div class="inputSearch">
                <div class="inputSelect">
                  <mat-select [placeholder]="'ATTENDANCE_LIST.month' | translate" [(ngModel)]="filters.month">
                    <mat-option *ngFor="let month of months" (click)="$event.stopPropagation();selectMonth(month)" [value]="month.name">
                      {{month.name}}
                    </mat-option>
                  </mat-select>
                </div>
                </div>
            </div>
          </div>
            <div class="select-date">
              <div>
                <div class="inputSearch">
                  <div class="inputSelect">
                    <mat-select placeholder="Year" [(ngModel)]="filters.year">
                      <mat-option *ngFor="let year of years" (click)="$event.stopPropagation();selectYear(year)" [value]="year">
                        {{year}}
                      </mat-option>
                    </mat-select>
                  </div>
                  </div>
              </div>
            </div>
          <!-- <div class="select-date">
            <div class="title">
              {{'VIEW_ATTENDANCE.from' | translate}}
            </div>
            <div>
                <input type="text" class="dateSelect" [matDatepicker]="from_date"  [(ngModel)]="date_filter.from_date" [max]="date_filter.to_date" (click)="from_date.open()"/>
                <mat-datepicker #from_date (closed)="setFromDateTime(date_filter)" [startAt]="date_filter.from_date"></mat-datepicker>
                <i class="material-icons calendar">date_range</i>
            </div>
        </div>
        <div class="select-date">
            <div class="title">
                    {{'VIEW_ATTENDANCE.to' | translate}}
            </div>
            <div >
                <input type="text"  class="dateSelect" [matDatepicker]="to_date" [(ngModel)]="date_filter.to_date" [min]="date_filter.from_date" [max]="date_filter.to_max" (click)="to_date.open()"/>
                <i class="material-icons icon calendar">date_range</i>
                <mat-datepicker #to_date (closed)="setToDateTime(date_filter)" [startAt]="date_filter.to_date" ></mat-datepicker>
            </div>
        </div> -->
        </div>
        <div class="content">
          <div class="bodyTop">
            <div class="left">
              <div class="leftContent">
                <div class="icon">
                  <img src="assets/1_Driver-Icon-Big.svg" alt="">
                </div>
              </div>
            </div>
            <div class="right">
              <div class="top">
                <div class="topSection">
                  <div class="topLeft">
                    <div class="details">
                      <div class="label">
                        {{'VIEW_ATTENDANCE.driver_type' | translate}}
                      </div>
                      <div class="colon">
                        :
                      </div>
                      <div class="value">
                        {{driver_data.driver_type}}
                      </div>
                    </div>
                    <div class="details">
                      <div class="label">
                        {{'VIEW_ATTENDANCE.no_of_days_present' | translate}}
                      </div>
                      <div class="colon">
                        :
                      </div>
                      <div class="value">
                        {{driver_data.present}}
                      </div>
                    </div>
                    <div class="details">
                      <div class="label">
                        {{'VIEW_ATTENDANCE.no_of_days_absent' | translate}}
                      </div>
                      <div class="colon">
                        :
                      </div>
                      <div class="value">
                        {{driver_data.absent}}
                      </div>
                    </div>
                    <div class="details">
                      <div class="label">
                        {{'VIEW_ATTENDANCE.paid_leave' | translate}}
                      </div>
                      <div class="colon">
                        :
                      </div>
                      <div class="value">
                        {{driver_data.paid_leaves}}
                      </div>
                    </div>
                    <!-- <div class="details">
                      <div class="label">
                        {{'VIEW_ATTENDANCE.lop' | translate}}
                      </div>
                      <div class="colon">
                        :
                      </div>
                      <div class="value">
                        1
                      </div>
                    </div> -->
                    <div class="details">
                      <div class="label">
                        {{'VIEW_ATTENDANCE.holidays' | translate}}
                      </div>
                      <div class="colon">
                        :
                      </div>
                      <div class="value">
                        {{driver_data.holidays}}
                      </div>
                    </div>
                  </div>
                  <div class="topRight">
  
                    <div class="month">
                      {{filters.month}} - {{filters.year}}
                    </div>
                    <!-- <div class="calendar">
                      <app-calendar></app-calendar>
                    </div>
                    <div class="legend">
                      <div>
                        <span class="dot" style="background-color: #104bb3;opacity: 0.7;"></span>
                        <span>Holidays</span>
                      </div>
                      <div>
                        <span class="dot" style="background-color: #019e10;opacity: 0.7;"></span>
                        <span>Present</span>
                      </div>
                      <div>
                        <span class="dot" style="background-color: #ff0209;opacity: 0.7;"></span>
                        <span>Absent</span>
                      </div>
                    </div> -->
  
                    <div class="table">
                      <table mat-table *ngIf="holidayList.length; else noData" [dataSource]="holidayList">
  
                        <ng-container matColumnDef="slno">
                          <th mat-header-cell *matHeaderCellDef style="padding-left: 3px;" >
                            {{'VIEW_ATTENDANCE.slno' | translate}}
                          </th>
                          <td mat-cell *matCellDef="let element">
                            {{element.index}}
                          </td>
                        </ng-container>
  
                        <ng-container matColumnDef="date">
                          <th mat-header-cell *matHeaderCellDef style="padding-left: 3px;" >
                            {{'VIEW_ATTENDANCE.date' | translate}}
                          </th>
                          <td mat-cell *matCellDef="let element">
                            {{element.date}}
                          </td>
                        </ng-container>
  
                        <ng-container matColumnDef="type">
                          <th mat-header-cell *matHeaderCellDef style="padding-left: 3px;" >
                            {{'VIEW_ATTENDANCE.type' | translate}}
                          </th>
                          <td mat-cell *matCellDef="let element">
                            {{element.status}}
                          </td>
                        </ng-container>
  
                        <ng-container matColumnDef="comment">
                          <th mat-header-cell *matHeaderCellDef style="padding-left: 3px;" >
                            {{'VIEW_ATTENDANCE.comment' | translate}}
                          </th>
                          <td mat-cell *matCellDef="let element">
                            {{element.comment}}
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayColumns;sticky:true;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
                      </table>
                      <ng-template #noData>
                        <div class="noData">
                          {{'VIEW_ATTENDANCE.noData' | translate}}
                        </div>
                      </ng-template>
                    </div>
  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  